interface IMealTypes {
  nothing: string;
  breakfast: string;
  lunch: string;
  dinner: string;
  breakfastAndDinner: string;
  breakfastAndLunch: string;
  lunchAndDinner: string;
  oneMealOnly: string;
  halfBoardIncluded: string;
  allMeals: string;
  midnightSnack: string;
  others: string;
}

export const MealTypes: IMealTypes = {
  nothing: "nothing",
  breakfast: "breakfast",
  lunch: "lunch",
  dinner: "dinner",
  breakfastAndDinner: "breakfast_and_dinner",
  breakfastAndLunch: "breakfast_and_lunch",
  lunchAndDinner: "lunch_and_dinner",
  oneMealOnly: "one_meal_only",
  halfBoardIncluded: "half_board_included",
  allMeals: "all_meals",
  midnightSnack: "midnight_snack",
  others: "others",
};

interface IMealTypeValues {
  nothing: number;
  breakfast: number;
  lunch: number;
  dinner: number;
  breakfastAndDinner: number;
  breakfastAndLunch: number;
  lunchAndDinner: number;
  allMeals: number;
}

export const MealTypeValues: IMealTypeValues = {
  nothing: 0,
  breakfast: 1,
  lunch: 2,
  dinner: 3,
  breakfastAndDinner: 4,
  breakfastAndLunch: 5,
  lunchAndDinner: 6,
  allMeals: 10,
};
